import { render, staticRenderFns } from "./pwa_action_groups.vue?vue&type=template&id=726b27bc&"
import script from "./pwa_action_groups.vue?vue&type=script&lang=js&"
export * from "./pwa_action_groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726b27bc')) {
      api.createRecord('726b27bc', component.options)
    } else {
      api.reload('726b27bc', component.options)
    }
    module.hot.accept("./pwa_action_groups.vue?vue&type=template&id=726b27bc&", function () {
      api.rerender('726b27bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/actions/groups/pwa_action_groups.vue"
export default component.exports